export default __webpack_public_path__ + "static/back_pain_woman-c9ae3b3c23f59a3ececf6771f63a44db.jpg";